// Auth API — session login/logout/whoami against the increment-2 backend.
import { ApiError } from "./client.ts";

export interface Identity {
  username: string;
  role: string; // "operator" | "reviewer"
  client_id: string | null;
  display_name: string;
}

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    credentials: "same-origin",
    ...init,
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const body = (await res.json()) as { detail?: string };
      if (body.detail) detail = body.detail;
    } catch {
      /* keep generic */
    }
    throw new ApiError(detail, res.status);
  }
  return (await res.json()) as T;
}

export function fetchWhoami(): Promise<Identity> {
  return req<Identity>("/api/v1/auth/whoami");
}

export function login(username: string, password: string): Promise<Identity> {
  return req<Identity>("/api/v1/auth/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });
}

export function logout(): Promise<{ ok: boolean }> {
  return req<{ ok: boolean }>("/api/v1/auth/logout", { method: "POST" });
}
